// extracted by mini-css-extract-plugin
module.exports = {"postGrid":"post-grid-module--postGrid--1M7dK","postGridItem":"post-grid-module--postGridItem--3PTLy"};